<template>
  <fragment>
    <div class="row" v-if="entity">
      <div class="col-4">
        <div class="form-group">
          
            <label class="col-form-label" for="abi">ABI</label>
            <input
              type="text"
              class="form-control required"
             :readonly="entity.isImported"
              id="abi"
              name="abi"
              :placeholder="entity.isImported?'':'ABI'"
              v-model="entity.ABI"
              
            />
       
        </div>
      </div>
       <div class="col-4">
        <div class="form-group">
          
            <label class="col-form-label" for="cab">CAB</label>
            <input
              type="text"
              class="form-control required"
              :readonly="entity.isImported"
              id="cab"
              name="cab"
              :placeholder="entity.isImported?'':'CAB'"
              v-model="entity.cab"
              
            />
       
        </div>
      </div>
       <div class="col-4">
        <div class="form-group">
          
            <label class="col-form-label" for="cin">CIN</label>
            <input
              type="text"
              class="form-control required"
             :readonly="entity.isImported"
              id="cin"
              name="cin"
               :placeholder="entity.isImported?'':'CIN'"
              v-model="entity.cin"
              
            />
       
        </div>
      </div>

       <div class="col-12">
        <div class="form-group">
          
            <label class="col-form-label" for="iban">IBAN</label>
            <input
              type="text"
              class="form-control required"
             :readonly="entity.isImported"
              id="iban"
              name="iban"
               :placeholder="entity.isImported?'':'IBAN'"
              v-model="entity.iban"
              
            />
       
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          
            <label class="col-form-label" for="bankaccount">Numero di conto</label>
            <input
              type="text"
              class="form-control required"
             :readonly="entity.isImported"
              id="bankAccount"
              name="bankAccount"
              :placeholder="entity.isImported?'':'Numero di Conto'"
              v-model="entity.bankaccount"
              
            />
       
        </div>
      </div>
    </div>
  </fragment>
</template>
<script>
import axios from "axios";
export default {
  name: "bankinformation",

  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: true,
    },
     entityType: {
      type: String,
      required: false,
       default: () => "company",
    },
    readOnlyReserved: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  components: {},
  data() {
    return {
      options: [],
      selectedTag: null,
      entity:null
    };
  },
  methods: {
    setVisibility(tag) {
      if (this.readOnly) return false;
      if (this.readOnlyReserved && tag.type.reserved) return false;
      return true;
    }
  },
 
   beforeMount() {
         /*   var me = this;
            
           
*/
let me = this;
 me.$nextTick(function () {      
            axios.get(`bank/${me.value}?type=${me.entityType}`).then(response => {
               
                me.entity = response.data;
            })
        });


        }
};
</script>
